import HTTP from "@/_helpers/http";
import { AUTHENTICATION__API } from "@/_helpers/urls";
import toast from "@/services/Notification";

const state = {
  registerInfo: {
    fname: "",
    lname: "",
    company_name: "",
    country: "",
    owner_type: 1,
    email: "",
    inv_referred_by: "",
    multiply_by: 0,
    password: "",
    confirmPassword: "",
    otp: "",
    referred_by: null,
    referred_by_manager: null,
    otpSent: 0,
    otpPhoneNo: "",
  },
  token: null,
  isOtpSent: false,
  isOtpVerified: false,
  isRegistered: false,
  registrationError: null,
  otp_via: null,
};

const mutations = {
  REGISTER_ACCOUNT_TYPE(state, type) {
    if (type === "Individual") {
      state.registerInfo.owner_type = 1;
      state.registerInfo.otpSent = 0;
    } else if (type === "Company") {
      state.registerInfo.owner_type = 2;
      state.registerInfo.otpSent = 0;
    }
  },
  SET_REGISTER_INFO(state, { field, value }) {
    state.registerInfo[field] = value;
  },
  SET_OTP_SENT(state, value) {
    state.isOtpSent = value;
  },
  SET_OTP_SENT_STEP(state, value) {
    state.registerInfo.otpSent = value;
  },
  SET_OTP_VERIFIED(state, value) {
    state.isOtpVerified = value;
  },
  SET_REGISTERED(state, value) {
    state.isRegistered = value;
    state.registerInfo.otpSent = 1;
  },
  SET_REGISTRATION_ERROR(state, error) {
    state.registrationError = error;
  },
  SET_TOKEN(state, data) {
    state.token = data;
  },
  RESET(state) {
    state.registerInfo.fname = "";
    state.registerInfo.lname = "";
    state.registerInfo.company_name = "";
    state.registerInfo.country = "";       
    state.registerInfo.email = "";
    state.registerInfo.inv_referred_by = "";
    state.registerInfo.multiply_by = "";
    state.registerInfo.password = "";
    state.registerInfo.confirmPassword = "";
    state.registerInfo.otp = "";
    state.registerInfo.referred_by = null;
    state.registerInfo.referred_by_manager = null;
    state.registerInfo.otpSent = 0;
  },
  SET_REFERRED_BY(state, value) {
    state.registerInfo.referred_by = value;
  },
  SET_MANAGER_REF_ID(state, value) {
    state.registerInfo.referred_by_manager = value;
  },
  OTP_VIA(state, value) {
    state.otp_via = value;
  },
};

const actions = {
  initializeReferral({ commit }) {
    const urlParams = new URLSearchParams(window.location.search);
    const refId = urlParams.get('referred_by');
    const managerRefId = urlParams.get('referred_by_manager');
    if (refId) {
      commit('SET_REFERRED_BY', refId);
    }
    if (managerRefId) {
      commit('SET_MANAGER_REF_ID', managerRefId);
    }
  },

  async isSmsOtp({ commit }) {
    try {
        const response = await HTTP({
            trackProgress: true,
            loadingText: 'Processing...'
        }).get(AUTHENTICATION__API.OTPVIA);
      
        commit("OTP_VIA", response?.data?.otp_via);
    } catch (error) {
        console.log(error);
    }
  },

  async sendOTP({ state, commit, dispatch }, payload = {}) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const inv_referred_by =
        payload.inv_referred_by || urlParams.get("inv_referred_by") || null;
      const referred_by =
        payload.referred_by || urlParams.get("referred_by") || null;
      const referred_by_manager =
        payload.referred_by_manager ||
        urlParams.get("referred_by_manager") ||
        null;

      const fullName =
        state.registerInfo.owner_type === 2
          ? state.registerInfo.company_name
          : `${state.registerInfo.fname} ${state.registerInfo.lname}`.trim();

      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(AUTHENTICATION__API.SENDREGISTEROTP, {
        name: fullName,
        country: state.registerInfo.country,
        email: state.registerInfo.email,
        inv_referred_by,
        multiply_by: state.registerInfo.multiply_by || null,
        password: state.registerInfo.password,
        owner_type: state.registerInfo.owner_type,
        otp: state.registerInfo.otp || null,
        referred_by,
        referred_by_manager,
        otp_phone_no: state.registerInfo.otpPhoneNo || null,
        otp_via: payload.otp_via || "emailOtp",
      });

      commit("SET_OTP_SENT", true);
      commit("SET_TOKEN", response?.data?.token || null);
      commit("SET_OTP_SENT_STEP", 1);

      toast.success(response?.data?.message);
      return response;
    } catch (error) {
      console.log(error?.response?.data?.message);
      commit("SET_OTP_SENT", false);
      commit("SET_OTP_SENT_STEP", 0);
      commit(
        "SET_REGISTRATION_ERROR",
        error?.response?.data?.message || "Failed to send OTP"
      );
      toast.error(error?.response?.data?.message || "Failed to send OTP");
      throw error;
    }
  },

  async previousStep({ state, commit }) {
    try {
      commit("SET_OTP_SENT_STEP", 0);
    } catch (error) {
      console.log(error);
      commit("SET_OTP_SENT", false);
    }
  },

  async verifyOTP({ state, commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(
        AUTHENTICATION__API.AUTHACCOUNTVERIFY,
        {
          code: state.registerInfo.otp,
          token: state.token,
          email: state.registerInfo.email 
        }
      );
      if (response.status === 200) {
        commit("SET_OTP_VERIFIED", true);
        return;
      }
    } catch (error) {
    commit("SET_OTP_VERIFIED", false);
    const message = error.response?.data?.message || "OTP verification failed";
    commit("SET_REGISTRATION_ERROR", message);
    toast.error(message);
    }
  },

  async register({ state, commit }) {
    try {
      let urlParams = new URLSearchParams(window.location.search);
      let referred_by =  urlParams.get('referred_by') || null;
      let inv_referred_by =  urlParams.get('inv_referred_by') || null;
      let referred_by_manager =  urlParams.get('referred_by_manager') || null;
      const res = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(AUTHENTICATION__API.AUTHREGISTER, {
        fname: state.registerInfo.fname,
        lname: state.registerInfo.lname,
        country: state.registerInfo.country,
        email: state.registerInfo.email,
        inv_referred_by: inv_referred_by,
        multiply_by: state.registerInfo.multiply_by || null,
        password: state.registerInfo.password,
        owner_type: state.registerInfo.owner_type,
        otp: state.registerInfo.otp,
        otpPhoneNo: state.registerInfo.otpPhoneNo,
        referred_by: referred_by,
        referred_by_manager: referred_by_manager,
      });
      console.log(res);
      commit("SET_REGISTERED", true);
      if(res.status == 200) {
        toast.success("Registration success");
        commit("RESET", true);
      }

    } catch (error) {
      console.log(error);
      commit("SET_REGISTRATION_ERROR", "Registration failed!");
      toast.error( error.response?.data?.message || "Registration failed!");
    }
  },
};

const getters = {
  getRegisterInfo: (state) => state.registerInfo,
  isOtpSent: (state) => state.isOtpSent,
  isOtpVerified: (state) => state.isOtpVerified,
  isRegistered: (state) => state.isRegistered,
  registrationError: (state) => state.registrationError,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
